import React from 'react';
import { AddressForm } from './Form';

export default function AddressesEdit(props) {
    return <AddressForm {...props} />;
}
